import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { staggerContainer, fadeInUp, scaleIn } from '../animations';
import { whyZafco } from '../data';

const ABOUT_IMAGES = [
  { src: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=600&q=80&fm=webp', alt: 'Corporate professionals — overseas placement consultations at ZAFCO', cls: 'rounded-2xl w-full h-48 object-cover',  w: 600, h: 400 },
  { src: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=600&q=80&fm=webp',  alt: 'Construction worker placed overseas through ZAFCO recruitment',       cls: 'rounded-2xl w-full h-64 object-cover',  w: 600, h: 500 },
  { src: 'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=600&q=80&fm=webp', alt: 'Hospitality staff deployed overseas via ZAFCO Gulf placements',       cls: 'rounded-2xl w-full h-64 object-cover',  w: 600, h: 500 },
  { src: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=600&q=80&fm=webp',  alt: 'Healthcare professional placed through ZAFCO international recruitment', cls: 'rounded-2xl w-full h-48 object-cover',  w: 600, h: 400 },
];

const AboutSection = () => (
  <section className="py-24 md:py-32 bg-slate-950">
    <div className="container max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid lg:grid-cols-2 gap-16 items-center">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
          variants={staggerContainer}
          className="relative"
        >
          <motion.div variants={scaleIn} className="grid grid-cols-2 gap-4">
            <div className="space-y-4">
              <img src={ABOUT_IMAGES[0].src} alt={ABOUT_IMAGES[0].alt} className={ABOUT_IMAGES[0].cls} width={ABOUT_IMAGES[0].w} height={ABOUT_IMAGES[0].h} loading="lazy" decoding="async" />
              <img src={ABOUT_IMAGES[1].src} alt={ABOUT_IMAGES[1].alt} className={ABOUT_IMAGES[1].cls} width={ABOUT_IMAGES[1].w} height={ABOUT_IMAGES[1].h} loading="lazy" decoding="async" />
            </div>
            <div className="space-y-4 pt-8">
              <img src={ABOUT_IMAGES[2].src} alt={ABOUT_IMAGES[2].alt} className={ABOUT_IMAGES[2].cls} width={ABOUT_IMAGES[2].w} height={ABOUT_IMAGES[2].h} loading="lazy" decoding="async" />
              <img src={ABOUT_IMAGES[3].src} alt={ABOUT_IMAGES[3].alt} className={ABOUT_IMAGES[3].cls} width={ABOUT_IMAGES[3].w} height={ABOUT_IMAGES[3].h} loading="lazy" decoding="async" />
            </div>
          </motion.div>
          <div className="absolute -bottom-6 -right-6 bg-[#C5A028] text-black rounded-2xl p-6 shadow-xl">
            <div className="text-4xl font-bold font-syne">15+</div>
            <div className="text-sm font-medium">Years Experience</div>
          </div>
        </motion.div>

        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true, margin: '-100px' }} variants={staggerContainer}>
          <motion.p variants={fadeInUp} className="text-[#C5A028] text-sm font-semibold uppercase tracking-widest mb-4">
            Our Track Record
          </motion.p>
          <motion.h2 variants={fadeInUp} className="font-syne text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
            10,000+ Indians Placed Overseas
          </motion.h2>
          <motion.p variants={fadeInUp} className="text-slate-400 text-lg mb-6 leading-relaxed">
            A Government of India–approved overseas recruitment and HR solutions partner,
            connecting exceptional Indian talent with prestigious employers across the
            <span className="text-white font-medium"> Gulf, Middle East, Northern Africa, and Europe</span> —
            with verified deployments to <span className="text-white font-medium">Saudi Arabia, UAE, Qatar and Kuwait</span> alone exceeding 7,500 workers.
          </motion.p>
          <motion.p variants={fadeInUp} className="text-slate-400 mb-8 leading-relaxed">
            Duly approved by the Ministry of External Affairs as a Recruitment Agency,
            Zafco operates with a compliance-first approach, ensuring every step—from
            sourcing to selection and deployment—is handled with transparency and accountability.
          </motion.p>

          <motion.div variants={fadeInUp} className="grid grid-cols-2 gap-4 mb-8">
            {whyZafco.map((item) => (
              <div key={item.title} className="flex items-start gap-3 p-4 rounded-xl bg-slate-900/50 border border-white/5">
                <item.icon className="w-5 h-5 text-[#C5A028] flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-white font-semibold text-sm">{item.title}</p>
                  <p className="text-slate-400 text-xs">{item.desc}</p>
                </div>
              </div>
            ))}
          </motion.div>

          <motion.div variants={fadeInUp}>
            <Link to="/about">
              <Button className="bg-transparent border border-[#C5A028] text-[#C5A028] hover:bg-[#C5A028] hover:text-black rounded-full px-8 py-6 font-semibold transition-all">
                More About Zafco
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
            </Link>
          </motion.div>
        </motion.div>
      </div>
    </div>
  </section>
);

export default AboutSection;
